/**
 * Labstep
 *
 * @module components/Organization/Analytics/OrganizationAnalyticsIntervalToggle
 * @desc Toggle component for switching between monthly/weekly intervals
 */

import { ORGANIZATION_ANALYTICS_INTERVAL } from 'labstep-web/constants/analytics';
import type React from 'react';
import { Button } from 'semantic-ui-react';
import styles from './styles.module.scss';

interface OrganizationAnalyticsIntervalToggleProps {
  interval: ORGANIZATION_ANALYTICS_INTERVAL;
  setInterval: (interval: ORGANIZATION_ANALYTICS_INTERVAL) => void;
}

export const OrganizationAnalyticsIntervalToggle: React.FC<
  OrganizationAnalyticsIntervalToggleProps
> = ({ interval, setInterval }) => {
  const handleToggle = (
    selectedInterval: ORGANIZATION_ANALYTICS_INTERVAL,
  ) => {
    setInterval(selectedInterval);
  };

  return (
    <div className={styles.toggleContainer}>
      <Button.Group toggle>
        <Button
          basic
          toggle
          active={
            interval === ORGANIZATION_ANALYTICS_INTERVAL.monthly
          }
          onClick={() =>
            handleToggle(ORGANIZATION_ANALYTICS_INTERVAL.monthly)
          }
          className={styles.toggleButton}
        >
          Monthly
        </Button>
        <Button
          basic
          toggle
          active={interval === ORGANIZATION_ANALYTICS_INTERVAL.weekly}
          onClick={() =>
            handleToggle(ORGANIZATION_ANALYTICS_INTERVAL.weekly)
          }
          className={styles.toggleButton}
        >
          Weekly
        </Button>
        <Button
          basic
          toggle
          active={interval === ORGANIZATION_ANALYTICS_INTERVAL.daily}
          onClick={() =>
            handleToggle(ORGANIZATION_ANALYTICS_INTERVAL.daily)
          }
          className={styles.toggleButton}
        >
          Daily
        </Button>
      </Button.Group>
    </div>
  );
};
